import React, { useState, useEffect } from 'react';
import { FormControl, TextField, Grid, Box, MenuItem, Checkbox, Typography, InputLabel, Button, Alert } from '@mui/material/';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from '@mui/material/Select';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie'

import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import FormLabel from '@mui/material/FormLabel';

import MembersList from '../../components/members/member_lst';
import jwt from 'jwt-decode'

import Officers from '../../components/clubs/officers';
import Address from '../../components/clubs/address';
import Facturation from '../../components/clubs/facturation';

import InvoiceBilling from '../../components/clubs/invoice_billing';
import Autorize from '../../components/ui/autorize';
import Meetings_schedules from '../../components/clubs/meetings_schedules';
import RapportAnnuel from '../../components/clubs/report_annual';
import DialogYesNo from '../../components/lib/dialog_yes_no';


import { getIsAdmin, getUserRule, getSessionExpirer } from '../../utils/userRule';

import "./club.css";
//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
export default function Club() {

    /*
    function getSessionStorageOrDefault(key, defaultValue) {
        const stored = sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
      }

    const clubIdFromSession = getSessionStorageOrDefault("clubId",0);
    const secteurFromSession = getSessionStorageOrDefault("secteur",0);*/

    const [openQuestion, setOpenQuestion] = React.useState(false);
    const [ruleRead, setRuleRead] = useState(false);
    const [ruleWrite, setRuleWrite] = useState(false);
    const [sessionValide, setSessionValide] = useState(false);
    const [clubid, setclubid] = useState("");
    const [secteur, setSecteur] = useState("");
    const [errorAxios, setErrorAxios] = useState(false);
    const [OptionStatusClub, setOptionStatusClub] = useState([]);
    const [showAlertAvantDisolution, setShowAlertAvantDisolution] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);


    const [isPayementEditable, setIsPayementEditable] = useState(false);


    const [memberslist, setMemberslist] = useState([]);
    const [clubInfo, setClubInfo] = React.useState({
        ClubName: "",
        ClubLegalName: "",
        City: "",
        clubFacebook: "",
        clubEmail: "",
        clubSiteWeb: "",
        Incorporated: "",
        Pending_Disbandment: "",
        Status_Reason: "",
        Status: "",
        State_Province_Code: "",
        Date_Revoked: "",
        Date_Charter: "",
        priorite_jeunesse_dateformation: "",
        fk_membre_prioritejeunesse: "",
        loi25_dateformation: "",
        fk_membre_loi25: "",
        annual_payement: ""
        // fk_club_parrain: "",
    });

    const [clubInfoStatic, setclubInfoStatic] = React.useState({
        Date_Added: "",
        Date_Changed: "",
        Last_ZoneNbr: "",
        Default_DistrictNbr: "",
    });

    /*
       const MyAxios = axios.create({
           headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
           withCredentials: true,
           xsrfCookieName: 'token',
           xsrfHeaderName: 'X-XSRF-TOKEN',
       })*/
    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })

    function handleChange(event) {
        const value = event.target.value;
        console.log(event.target.id + "== " + value);
        setClubInfo({
            ...clubInfo,
            [event.target.id]: value,
        });
    }

    function handleChangeSelectProvince(event) {
        const value = event.target.value;
        setClubInfo({
            ...clubInfo, "State_Province_Code": value,
        });
    }


    function handleChangeSelectStatus(event) {
        const value = event.target.value;
        setClubInfo({
            ...clubInfo, "Status": value,
        });

        if (value === "D" || value === "R")
            setShowAlertAvantDisolution(true);
        else
            setShowAlertAvantDisolution(false);

    }


    function handleChangePrioriteJeunesseMembre(event) {
        const value = event.target.value;
        setClubInfo({
            ...clubInfo, "fk_membre_prioritejeunesse": value,
        });

    }

    function handleChangeLoi25Membre(event) {
        const value = event.target.value;
        setClubInfo({
            ...clubInfo, "fk_membre_loi25": value,
        });

    }




    useEffect(() => {

        const currentMonth = new Date().getMonth();
        // Vérifier si on est en juillet (6), août (7) ou septembre (8)
        //if (currentMonth >= 6 && currentMonth <= 8) {
            setIsPayementEditable(true);
        //} else {
        //    setIsPayementEditable(false);
        //}



        const fetchData = async () => {
            try {

                setIsAdmin(await getIsAdmin());
                // Vos opérations asynchrones, par exemple une requête HTTP
                let RuleRead_Club = await getUserRule("read_club", sessionStorage.getItem('clubId'), sessionStorage.getItem('secteur'));
                let RuleWrite_Club = await getUserRule("write_club", sessionStorage.getItem('clubId'), sessionStorage.getItem('secteur'));

                setRuleWrite(RuleWrite_Club);
                setRuleRead(RuleRead_Club);

                if (RuleRead_Club === true) {
                    updateDisplay(sessionStorage.getItem('clubId'), sessionStorage.getItem('secteur'));
                    //************ load liste status possible 
                    MyAxios.get(process.env.REACT_APP_API + '/lookup/getStatusClub') // + this.props.url)
                        .then((res) => {
                            setErrorAxios(false);
                            setOptionStatusClub(res.data);
                        })
                        .catch((error) => {
                            setErrorAxios(true);

                        });
                    //********************************************** 
                }


                console.log("RuleRead_Club", RuleRead_Club);
                // Faire quelque chose avec les données
            } catch (error) {
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
            }
        };

        fetchData(); // Appel de la fonction asynchrone


        // console.log("RuleRead_Club",RuleRead_Club);

        //setRuleRead(RuleRead_Club);
        //setRuleWrite(RuleWrite_Club);
        //setSessionValide(getSessionExpirer());

        //  alert(RuleRead_Club);

        if (clubid === "") {
            setclubid(sessionStorage.getItem('clubId'));
            setSecteur(sessionStorage.getItem('secteur'));
        }


    }, [clubid, secteur]);


    function updateDisplay(clubid, secteur) {


        //console.log("----------------" + secteur + "------------------------------------------");
        MyAxios.get(process.env.REACT_APP_API + "/clubs/secteur/" + secteur + "/getClub/" + clubid) //  + this.props.clubid+ state.clubid
            .then((res) => {
                console.log(res.data[0]);

                setClubInfo({
                    ...clubInfo,
                    "ClubLegalName": res.data[0].ClubLegalName,
                    "ClubName": res.data[0].ClubName,
                    "City": res.data[0].City,
                    "clubFacebook": res.data[0].clubFacebook,
                    "clubEmail": res.data[0].clubEmail,
                    "clubSiteWeb": res.data[0].clubSiteWeb,
                    "Incorporated": res.data[0].Incorporated,
                    "Pending_Disbandment": res.data[0].Pending_Disbandment,
                    "Status": res.data[0].Status,
                    "Date_Revoked": res.data[0].Date_Revoked,
                    "State_Province_Code": res.data[0].State_Province_Code,
                    "Date_Charter": res.data[0].Date_Charter,

                    "priorite_jeunesse_dateformation": res.data[0].priorite_jeunesse_dateformation,
                    "fk_membre_prioritejeunesse": res.data[0].fk_membre_prioritejeunesse,

                    "loi25_dateformation": res.data[0].loi25_dateformation,
                    "fk_membre_loi25": res.data[0].fk_membre_loi25,
                    "annual_payement": res.data[0].annual_payement,

                    //"fk_club_parrain":   res.data[0].fk_club_parrain,
                });

                setclubInfoStatic({
                    ...clubInfoStatic,
                    "Date_Added": res.data[0].Date_Added,
                    "Date_Changed": res.data[0].Date_Changed,
                    "Default_DistrictNbr": res.data[0].Default_DistrictNbr,
                    "Solde": res.data[0].total,
                    "Solde_update": res.data[0].dateFacture

                });

            })
            .catch((error) => {
                console.log("ERROR:" + error);


            });

        MyAxios.get(process.env.REACT_APP_API + '/members/get/secteur/' + secteur + '/club/' + clubid + '/actifonly/true')
            .then((res) => {
                setMemberslist(res.data);
            })
            .catch((error) => {
                console.log("ERROR:" + error);
            });


        //  }

    }



    function onCloseDialog() {
        setOpenQuestion(false);
    }


    function DialogResponse(response) {
        if (response === true) {
            SaveChange()
        }
    }



    function SaveChangeClick() {


        if (showAlertAvantDisolution === true)
            setOpenQuestion(true);
        else
            SaveChange()

    }

    function SaveChange() {


        MyAxios.post(process.env.REACT_APP_API + "/clubs/secteur/" + secteur + "/UpdateClub/" + clubid, clubInfo)
            .then((res) => {
                console.log(res)
                if (res.status === 200)
                    alert("Sauvegarde complété")
                else
                    alert("Erreur sauvegarde")

            })
            .catch((error) => {
                console.log(error)
                alert("Erreur sauvegarde")
            });

    }

    function getOnlyDate(tmp) {
        return tmp.substring(0, 10);
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }


    function setDateRevoquer(MYValue) {

        //  const value = event.target.value;  
        setClubInfo({
            ...clubInfo, "Date_Revoked": MYValue,
        });
    }


    function setDateFondation(MYValue) {

        //  const value = event.target.value;  
        setClubInfo({
            ...clubInfo, "Date_Charter": MYValue,
        });
    }

    function setDateFormation(MYValue) {
        setClubInfo({
            ...clubInfo, "priorite_jeunesse_dateformation": MYValue,
        });
    }

    function setDateFormationLoi25(MYValue) {
        setClubInfo({
            ...clubInfo, "loi25_dateformation": MYValue,
        });
    }

    const getIsPayementAnnuel = () => {

        if (clubInfo.annual_payement === 0)
            return "Trimestriel";
        else
            return "Annuel";


    };

    const getOnlyAdminButton = () => {
        //async function getOnlyAdminButton()
        //{

        let cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        // console.log(cookieValue);
        if (cookieValue) {
            if (isAdmin === true) {
                return (<>


                    <Grid item xs={11} sx={{ borderRadius: 3, paddingBottom: 2 }}  >
                        <TextField id="ClubLegalName" value={clubInfo.ClubLegalName} onChange={handleChange} label="Nom légal de club" fullWidth />
                    </Grid>
                    <Grid item xs={11} sx={{ borderRadius: 3, paddingBottom: 2 }}   >
                        <TextField id="City" value={clubInfo.City} onChange={handleChange} label="Ville" fullWidth />
                    </Grid>



                    <Grid item xs={11} sx={{ borderRadius: 3, padding: 2, marginBottom: 2 }} style={{ border: "1px solid grey" }}   >
                        <div><Typography variant="h7" gutterBottom>Statut de club:  {clubInfo.Status}    </Typography></div>
                        <div><Typography variant="h7" gutterBottom>Date de fondation de club:  {clubInfo.Date_Charter}    </Typography></div>
                        <div><Typography variant="h7" gutterBottom>En attente de dissolution:  {clubInfoStatic.Pending_Disbandment}      </Typography></div>
                    </Grid>


                    <Grid item xs={11} sx={{ borderRadius: 3, padding: 2, marginBottom: 2 }} style={{ border: "1px solid grey" }}   >
                        <legend >
                            Edition des dates
                        </legend>

                        <Grid item xs={12} container direction="row"  >
                            <Grid item xs={6} sx={{ borderRadius: 3, paddingBottom: 2 }}  >
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>

                                    <DatePicker
                                        id="Date_Revoked"
                                        label="Date de révocation"
                                        key="Date_Revoked"
                                        name="Date_Revoked"
                                        inputFormat="YYYY-MM-DD"
                                        value={clubInfo.Date_Revoked}
                                        onChange={(newValue) => setDateRevoquer(formatDate(newValue))}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={6} sx={{ borderRadius: 3, paddingBottom: 2 }}  >
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>

                                    <DatePicker
                                        id="Date_Charter"
                                        label="Date de fondation"
                                        key="Date_Charter"
                                        name="Date_Charter"
                                        inputFormat="YYYY-MM-DD"
                                        value={clubInfo.Date_Charter}
                                        onChange={(newValue) => setDateFondation(formatDate(newValue))}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>

                    </Grid>


                    <Grid item xs={11} container direction="row" sx={{ borderRadius: 3, padding: 2, marginBottom: 2 }} style={{ border: "1px solid grey" }}  >

                        <Grid item xs={6} >

                            <FormControl sx={{ minWidth: 200 }}>
                                <InputLabel id="StatusDuClub">Statut de club</InputLabel>
                                <Select
                                    labelId="StatusDuClub"
                                    id="Status"
                                    value={clubInfo.Status}
                                    label="Statut du club"
                                    onChange={handleChangeSelectStatus}
                                >

                                    {OptionStatusClub.map(p => (
                                        <MenuItem key={"name-shared" + p.id} value={p.id}>
                                            {p.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6} sx={{ paddingTop: 1 }} >
                            <FormControl sx={{ minWidth: 200, }}>
                                <InputLabel id="State_Province_Code">Province du club</InputLabel>
                                <Select
                                    labelId="State_Province_Code"
                                    id="State_Province_Code"
                                    value={clubInfo.State_Province_Code}
                                    label="Province du club"
                                    onChange={handleChangeSelectProvince}
                                >

                                    <MenuItem key={"name-shared" + "AB"} value="AB">Alberta</MenuItem>
                                    <MenuItem key={"name-shared" + "BC"} value="BC">Colombie-Britannique</MenuItem>
                                    <MenuItem key={"name-shared" + "PE"} value="PE">Île-du-Prince-Édouard</MenuItem>
                                    <MenuItem key={"name-shared" + "MB"} value="MB">Manitoba</MenuItem>
                                    <MenuItem key={"name-shared" + "NB"} value="NB">Nouveau-Brunswick</MenuItem>
                                    <MenuItem key={"name-shared" + "NS"} value="NS">Nouvelle-Écosse</MenuItem>
                                    <MenuItem key={"name-shared" + "ON"} value="ON">Ontario</MenuItem>
                                    <MenuItem key={"name-shared" + "SK"} value="SK">Saskatchewan</MenuItem>
                                    <MenuItem key={"name-shared" + "NL"} value="NL">Terre-Neuve-et-Labrador</MenuItem>
                                    <MenuItem key={"name-shared" + "QC"} value="QC">Québec</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>


                        <Grid item xs={6} sx={{ paddingTop: 1 }} >
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">Incorporé</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    onChange={handleChange}
                                    value={clubInfo.Incorporated}
                                >
                                    <FormControlLabel value="T" control={<Radio id="Incorporated" />} label="Oui" />
                                    <FormControlLabel value="F" control={<Radio id="Incorporated" />} label="Non" />

                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sx={{ paddingTop: 1 }} >
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">En attente de dissolution</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    onChange={handleChange}
                                    value={clubInfo.Pending_Disbandment}
                                >
                                    <FormControlLabel value="1" control={<Radio id="Pending_Disbandment" />} label="Oui" />
                                    <FormControlLabel value="0" control={<Radio id="Pending_Disbandment" />} label="Non" />

                                </RadioGroup>
                            </FormControl>
                        </Grid>


                        <Grid item xs={12} sx={{ borderRadius: 3, padding: 2, marginTop: 2 }} style={{ border: "1px solid grey" }} >
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">Fréquence des paiements:</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    onChange={handleChange}
                                    value={clubInfo.annual_payement}

                                >
                                    {isPayementEditable === true ? <>
                                        <FormControlLabel value="0" control={<Radio id="annual_payement" />} label="Trimestriel" />
                                        <FormControlLabel value="1" control={<Radio id="annual_payement" />} label="Annuel" />
                                    </>
                                        : <>
                                            <FormControlLabel value="0" control={<Radio id="annual_payement" disabled />} label="Trimestriel" />
                                            <FormControlLabel value="1" control={<Radio id="annual_payement" disabled />} label="Annuel" />
                                        </>
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>


                </>);

            }
            else {
                return (<>

                    <Grid container xs={11} direction="row" sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}   >


                        <Grid item xs={11}>         <Typography variant="h6" gutterBottom> {clubInfo.ClubLegalName}   </Typography> </Grid>
                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Ville:     </Typography>  </Grid>  <Grid item xs={6}>    <Typography variant="h7" gutterBottom>{clubInfo.City}   </Typography> </Grid>
                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Incorporé:      </Typography>  </Grid>  <Grid item xs={6}><Typography variant="h7" gutterBottom> {clubInfo.Incorporated === "T" ? 'Oui' : 'Non'}  </Typography> </Grid>
                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Province de club:     </Typography>  </Grid>  <Grid item xs={6}>  {clubInfo.State_Province_Code}  </Grid>

                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Statut de club:      </Typography> </Grid>  <Grid item xs={6}> {clubInfo.Status === "A" ? "Actif" : "Inactif"}   </Grid>
                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Date de fondation de club:      </Typography>        </Grid>  <Grid item xs={6}>  {clubInfoStatic.Date_Charter}   </Grid>
                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Date de révocation:     </Typography>     </Grid>  <Grid item xs={6}> {clubInfoStatic.Date_Revoked}   </Grid>
                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Date de dissolution:       </Typography>    </Grid>  <Grid item xs={6}>   {clubInfoStatic.Pending_Disbandment}     </Grid>
                        <Grid item xs={6}>          <Typography variant="h7" gutterBottom>Fréquence des paiements:       </Typography>    </Grid>  <Grid item xs={6}>   {getIsPayementAnnuel()}     </Grid>

                    </Grid>
                </>);
            }
        }
    }
    //***** return validation ****** ruleAcces={ruleRead}
    return (
        <div>
            <Autorize axiosError={errorAxios} sessionExpirer={sessionValide} />
            {getMain()}
        </div>
    );



    function getSaveButton() {
        if (ruleWrite === true) {
            return (
                <Grid item xs={11}   >

                    {showAlertAvantDisolution === true ? <Alert severity="warning">À la sauvegarde, le club sera dissous et les membres seront tous désactivés.</Alert> : null}

                    <Button onClick={SaveChangeClick} sx={{ maxwidth: 200, maxheight: 50, padding: 2, margin: 2 }} variant="containedFifth">CLIQUEZ ICI POUR ENREGISTRER</Button>
                </Grid>);
        }

    }

    function getIfResponsableprioriteJeunesse() {
        if (clubInfo.priorite_jeunesse === true || clubInfo.priorite_jeunesse === 1 || clubInfo.priorite_jeunesse === "1") {
            return true;

        }
        else
            return false;

    }




    function getMain() {

        if (ruleRead === true) {

            return (<form>
                <Grid container direction="row" spacing={2} sx={{ marginLeft: 5 }}  >

                    <Grid item xs={11} sx={{ marginLeft: 2 }} >


                        <Grid item container direction="row" spacing={2} sx={{ padding: 1, margin: 1, borderRadius: 3, marginLeft: 1, paddingBottom: 2, }} style={{ border: "1px solid grey" }} >
                            <Grid item xs={4}>
                                <Typography variant="h6" gutterBottom>Secteur  {secteur},  club  {clubid}</Typography>
                            </Grid>
                            <Grid item xs={7} >
                                <Typography variant="h6" gutterBottom>Date de fondation de club: {getOnlyDate(clubInfo.Date_Charter)}</Typography>
                            </Grid>
                        </Grid>

                        <Grid item container spacing={2} sx={{ padding: 1, margin: 1, borderRadius: 3, marginLeft: 1 }} style={{ border: "1px solid grey" }}  >
                            <Grid item xs={5}>
                                {getOnlyAdminButton()}
                            </Grid>

                            <Grid item xs={6}>
                                <Grid item container direction="row" spacing={2}   >

                                    <Grid item xs={6} sx={{ borderRadius: 3 }}   >
                                        <TextField id="clubFacebook" value={clubInfo.clubFacebook} onChange={handleChange} label="Facebook de club" fullWidth />
                                    </Grid>

                                    <Grid item xs={5} sx={{ borderRadius: 3 }}   >
                                        <TextField id="clubEmail" value={clubInfo.clubEmail} onChange={handleChange} label="Courriel de club" fullWidth />
                                    </Grid>

                                    <Grid item xs={11} sx={{ borderRadius: 3 }}   >
                                        <TextField id="clubSiteWeb" value={clubInfo.clubSiteWeb} onChange={handleChange} label="Site Web de club" fullWidth />
                                    </Grid>





                                    <Grid item xs={12} sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}   >
                                        <Box >
                                            <legend >
                                                <Typography component="span" >
                                                    Responsable Les jeunes avant tout!  
                                                    <Typography component="span" sx={{ fontStyle: 'italic' ,paddingLeft:1 }}>Prévention des abus pédosexuels
                                                    </Typography>
                                                </Typography>

                                            </legend>

                                            <Grid item container direction="row" spacing={2} sx={{ marginTop: 1 }}  >

                                                <Grid item xs={6} >

                                                    <FormControl sx={{ minWidth: 200 }} fullWidth>
                                                        <InputLabel id="fk_membre_prioritejeunesse">Membre</InputLabel>
                                                        <Select
                                                            labelId="fk_membre_prioritejeunesse"
                                                            id="fk_membre_prioritejeunesse"
                                                            value={clubInfo.fk_membre_prioritejeunesse}
                                                            label="Membre"
                                                            fullWidth
                                                            onChange={handleChangePrioriteJeunesseMembre}
                                                        >

                                                            {memberslist.map(p => (
                                                                <MenuItem key={"name-shared" + p.id} value={p.id}>
                                                                    {p.First_Name} {p.Last_Name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <LocalizationProvider fullWidth dateAdapter={AdapterDayjs} adapterLocale='fr'>

                                                        <DatePicker
                                                            id="priorite_jeunesse_dateformation"
                                                            label="Date de formation complétée"
                                                            key="priorite_jeunesse_dateformation"
                                                            name="priorite_jeunesse_dateformation"
                                                            inputFormat="YYYY-MM-DD"
                                                            value={clubInfo.priorite_jeunesse_dateformation}
                                                            fullWidth
                                                            onChange={(newValue) => setDateFormation(formatDate(newValue))}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                            </Grid>
                                        </Box>


                                    </Grid>

                                    <Grid item xs={12} sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}   >
                                        <Box  >
                                            <legend >
                                                Responsable Loi 25
                                            </legend>

                                            <Grid item container direction="row" spacing={2} sx={{ marginTop: 1 }}  >

                                                <Grid item xs={6} >

                                                    <FormControl sx={{ minWidth: 200 }} fullWidth>
                                                        <InputLabel id="fk_membre_loi25">Membre</InputLabel>
                                                        <Select
                                                            labelId="fk_membre_loi25"
                                                            id="fk_membre_loi25"
                                                            value={clubInfo.fk_membre_loi25}
                                                            label="Membre"
                                                            fullWidth
                                                            onChange={handleChangeLoi25Membre}
                                                        >

                                                            {memberslist.map(p => (
                                                                <MenuItem key={"name-shared" + p.id} value={p.id}>
                                                                    {p.First_Name} {p.Last_Name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <LocalizationProvider fullWidth dateAdapter={AdapterDayjs} adapterLocale='fr'>

                                                        <DatePicker
                                                            id="loi25_dateformation"
                                                            label="Date"
                                                            key="loi25_dateformation"
                                                            name="loi25_dateformation"
                                                            inputFormat="YYYY-MM-DD"
                                                            value={clubInfo.loi25_dateformation}
                                                            fullWidth
                                                            onChange={(newValue) => setDateFormationLoi25(formatDate(newValue))}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                            </Grid>

                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>




                            {getSaveButton()}

                        </Grid>


                        <Grid item container direction="row" spacing={2} sx={{ padding: 1, margin: 1, borderRadius: 3, marginLeft: 1, paddingBottom: 2, }} >
                            <Grid item sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>
                                <Meetings_schedules key="meetingslistNow" clubid={clubid} secteur={secteur} ruleWrite={ruleWrite} />
                            </Grid>

                            <Grid item sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>
                                <Officers key="officerlistNow" clubid={clubid} secteur={secteur} addyear='0' ruleWrite={ruleWrite} />
                            </Grid>

                            <Grid sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>
                                <Officers key="officerlistNext" clubid={clubid} secteur={secteur} addyear='1' ruleWrite={ruleWrite} />
                            </Grid>

                            <Grid sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>

                               
                                <Address key="ClubAdress" clubid={clubid} secteur={secteur} ruleWrite={ruleWrite} />

                            </Grid>



                            <Grid xs={12} sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>
                                
                                <MembersList key="MyListMembre" clubid={clubid} secteur={secteur} ruleWrite={ruleWrite} />
                            </Grid>


                            <Grid xs={12} sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>
                                <Grid item>
                                    <Typography variant="h6" gutterBottom>Facturation</Typography>
                                </Grid>
                                <Facturation key="MyListFacturation" clubid={clubid} secteur={secteur} ruleWrite={ruleWrite} solde={clubInfoStatic.Solde} />
                            </Grid>




                            <Grid xs={12} sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>
                                <Grid item>
                                    <Typography variant="h6" gutterBottom>Rapport</Typography>
                                </Grid>
                                <RapportAnnuel key="MyRapportAnnuel" clubid={clubid} secteur={secteur} ruleWrite={ruleWrite} />
                            </Grid>





                            <Grid sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "1px solid grey" }}>
                                <Typography variant="h6" gutterBottom>Mode de paiement</Typography>

                                <Grid container spacing={2} >

                                   
                                    <Grid item sx={6} >
                                        <Card sx={{ maxWidth: 500, padding: 1, margin: 1 }}>
                                            <CardContent>
                                                <Typography sx={{ fontSize: 17 }} color="text.primary" gutterBottom>
                                                    Mode de paiement : virement bancaire
                                                </Typography>
                                                <Typography variant="body2">
                                                   Paiement par virement bancaire disponible auprès de la Caisse Desjardins. <br />
                                                  Veuillez utiliser votre numéro de club à 5 chiffres comme numéro de compte pour un virement bancaire.
                                                   <br /><br />
                            
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                     <Grid item sx={6} >
                                        <Card sx={{ maxWidth: 500, padding: 1, margin: 1 }}>
                                            <CardContent>


                                                <Typography sx={{ fontSize: 17 }} color="text.primary" gutterBottom>
                                                    Mode de paiement :  Par chèque
                                                </Typography>
                                                <Typography variant="body2">
                                                    Envoyer votre chèque à : <br />
                                                    Opti-jeunesse 5205, boul. <br />
                                                    Métropolitain Est Bureau 200, <br />
                                                    2e étage Montréal, QC H1R 1Z7<br />
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                     <Grid item sx={6} >
                                        <Card sx={{ maxWidth: 500, padding: 1, margin: 1 }}>
                                            <CardContent>
                                                <Typography sx={{ fontSize: 17 }} color="text.primary" gutterBottom>
                                                    Mode de paiement : virement Interac
                                                </Typography>
                                                <Typography variant="body2">
                                                   Veuillez utiliser le numéro de facture comme référence du paiement. <br />
                                                   Envoyez les fonds à Opti-jeunesse : comptabilite@opti-jeunesse.org. <br />
                                                   Réponse à la question secrète : JEUNESSE<br />
                                                   <br /><br />                                            
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid >
                    </Grid >
                </Grid>
                <DialogYesNo question="Voulez-vous vraiment révoqué/dissoudre ce club? Les membre encore actif seront radiés" onAnswer={DialogResponse} open={openQuestion} onClose={onCloseDialog} />
            </form >);
        }
    }
}



/*
 old facturation box.
  <Box sx={{ borderRadius: 3,padding:1,margin:1}}  style={{ border: "1px solid grey" }}>
                            
                                <Typography variant="h6" gutterBottom>Facturation</Typography>                                              
                                <InvoiceBilling key="invoicebill"  clubid={clubid} secteur={secteur}  />
                                
   </Box>

*/